import { pathToAction } from 'redux-first-router';
import routesGenerator from '@/router/routesGenerator';
import { ROUTE_COMPANY } from '@/constants/routes';
import { isValidSection } from '@/pages/CompanySplit/useSection';
import { isCompanySplit } from '@/hooks/useCompanySplitDetect';

export function getCurrentRoute() {
  try {
    const action = pathToAction(window.location.pathname, routesGenerator());
    if (action.type === ROUTE_COMPANY) {
      const { payload } = action;
      const canonicalURL = `/stocks/${payload.isoCode2}/${payload.industry}/${payload.exchange_ticker}/${payload.companyname}`;
      if (isCompanySplit(canonicalURL)) {
        const { section } = payload;
        if (typeof section === 'string' && isValidSection(section)) {
          return `${action.type}/SPLIT/${section.toUpperCase()}`;
        }
        return `${action.type}/SPLIT`;
      }
    }
    return action.type;
  } catch {
    return 'unmapped';
  }
}
